import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { AdminAuthContextProvider } from './administrator/admin/AdminAuthContext';
import { CustomerAuthContextProvider } from './customer/commoncomponents/CustomerAuthContext';
import { BusinessAuthContextProvider } from './business/commoncomponents/BusinessAuthContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <AdminAuthContextProvider>
      <CustomerAuthContextProvider>
          <BusinessAuthContextProvider>
              <App />
          </BusinessAuthContextProvider>
      </CustomerAuthContextProvider>
     </AdminAuthContextProvider>
  </React.StrictMode>
);
